import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

import { CarrierService } from '../services';
import { CARRIER_LIST_KEY } from '../constants';

const useCarrierUpdateActive = (providerId: string, onClose?: () => void) => {
  const { t } = useTranslation(['carriers', 'errors']);
  const queryClient = useQueryClient();

  return useMutation((active: boolean) => CarrierService.updateActive(providerId, { active }), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CARRIER_LIST_KEY] });
      toast.success(t('carriers:visibilitySuccessUpdate'));
      onClose?.();
    },
    onError: () => {
      toast.error(t('generalErrorMessage', { ns: 'errors' }));
    },
  });
};

export default useCarrierUpdateActive;
